import Navigation from "./personal-area/Navigation";
import {Outlet, useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {credentials} from "../../api/customer";
import {CustomerCredentialResponse} from "../../interfaces/api/CustomerCredentialResponseInterface";
import {useContext, useEffect, useState} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";

export default function PersonalArea() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [error, setError] = useState('')

    const navigate = useNavigate()

    const {data , status} = useQuery<CustomerCredentialResponse,  "error" | "success" | "pending">({
        queryKey: [...['customer', 'credentials', state.codeword]],
        queryFn: () => credentials(state.customer.id || 0, state.customer.sign || '') ,
        retry: false,
        enabled: !!(state.customer.id && state.customer.sign)
    })

    useEffect(() => {
        if(!state.customer.id  ||  !state.customer.sign){
            navigate('/')
            return
        }
        switch(status){
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.SUCCESS})
                setError('В процессе выполнения запроса возникли ошибки')
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                dispatch({type: ReducerActionType.SET_PARAM, paramName: 'customer', payload: data.customer})
                return;
        }


    }, [status]);

    return (<main className="main-lk">
            <section className="lk">
                <div className="container-fluid">
                    {status === 'error' && <div className="row lk__wrap">
                        <h3 className={'text-center text-danger'}>{error}</h3>

                    </div>}
                    {status === 'success' && <div className="row lk__wrap">
                        <div className="col-lg-2 lk__menu">
                            <Navigation customer={data.customer}/>
                        </div>
                        <div className="col-lg-10 lk__container">
                            <div className="tab-content">
                                <Outlet context={data}/>
                            </div>
                        </div>
                    </div>}
                </div>
            </section>
        </main>
    )
}